import { Box } from "@mui/material";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { LoadingSpinner } from "../LoadingSpinner";
import { TextButton, type TextButtonProps } from "../TextButton";

export interface LoadingTextButtonProps extends TextButtonProps {
  isLoading: boolean;
}

/**
 * A text button that renders a loading spinner in place of the text while the button is loading.
 * Uses `TextButton` internally, so it supports all the same props.
 */
export function LoadingTextButton(props: LoadingTextButtonProps) {
  const { isLoading, sx, disabled, children, ...restProps } = props;

  return (
    <TextButton
      {...restProps}
      {...(isLoading && { role: "progressbar" })}
      disabled={isLoading || disabled}
      sx={mergeSxProps(sx, {
        ...(isLoading && {
          textDecorationColor: "transparent",
          "& svg": { visibility: "hidden" },
        }),
      })}
    >
      {isLoading && (
        <Box
          component="span"
          sx={{
            position: "absolute",
            display: "flex",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LoadingSpinner size="small" variant="primary" />
        </Box>
      )}
      <Box component="span" sx={{ visibility: isLoading ? "hidden" : "visible" }}>
        {children}
      </Box>
    </TextButton>
  );
}
